import { useQuery } from "@tanstack/react-query";
import { userQueryKey } from "../user-state/userStateQueryKeys";
import { fetchSession, type SessionResponse } from "./userApiClient";

export interface UseUserQueryOptions {
  /** SSR-provided session (e.g. pageContext.user) to seed the cache with, skipping the initial fetch. */
  initialData?: SessionResponse;
}

/**
 * `useQuery` wrapper around the same session data `AuthContext.tsx` fetches. Per TEC-404's
 * `staleTime: Infinity`: identity data doesn't go stale on its own — it only changes via an
 * explicit sign-in/sign-out (a full navigation in this app, see `AuthContext.signIn`/`signOut`),
 * so there's nothing to background-refetch.
 */
export function useUserQuery(options?: UseUserQueryOptions) {
  return useQuery({
    queryKey: userQueryKey,
    queryFn: fetchSession,
    staleTime: Infinity,
    initialData: options?.initialData,
  });
}
